var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.2571 12.7429L67.4434 32.5566",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4774 56.5225L21.9082 78.0917",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4775 56.5225C43.4775 56.5225 55.2098 35.2039 57.857 32.5567C60.5042 29.9095 64.7961 29.9095 67.4433 32.5567C70.0905 35.2039 70.0905 39.4958 67.4433 42.143C64.7961 44.7902 43.4775 56.5225 43.4775 56.5225Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7565 73.4863L21.9087 78.0917L26.5141 84.2439C30.2569 89.2439 38.1649 87.3427 39.226 81.1877L43.4779 56.5225L18.8127 60.7744C12.6577 61.8354 10.7565 69.7435 15.7565 73.4863Z",
    stroke: "#171A1F",
    strokeWidth: 3.07692,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart1);
export default __webpack_public_path__ + "static/media/Dart 1.fd1986c6fee2342ac4a8ea4ff2befc37.svg";
export { ForwardRef as ReactComponent };